import React from 'react';
import Header from '../components/Header'
import BoxWrapper from '../components/BoxWrapper/BoxWrapper';
import List from './web-hook/List'

const WebHook = () => {
	return (
		<>
			<Header />

			<BoxWrapper>
				<List />
			</BoxWrapper>
		</>
	)
}

export default WebHook